export default (link: string) => {
    if (window.location.pathname === link) {
        window?.scrollTo(0, 0);
    }
};
